import { decamelizeKeys } from 'humps';
function eventType() {
  var eventTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (data) {
    return data;
  };
  return function (data) {
    var quizSessionId = data.quizSessionId,
      accountUuid = data.accountUuid;
    var createdAt = "".concat(new Date().toISOString(), "|").concat(window.performance.now());
    var quizSessionKey = "".concat(quizSessionId, "|").concat(accountUuid);
    var serializedData = JSON.stringify(decamelizeKeys(Object.assign(eventTransform(data), {
      createdAt: createdAt
    })));

    // AWS-SDK uses capitalized properties :\
    return {
      Data: serializedData,
      PartitionKey: quizSessionKey
    };
  };
}
export var RESPONSE = eventType(function (data) {
  // The resume (response_events) stream doesn't care about eventData contents
  // Clean them up!

  // Required to prevent modification of the source data
  var adjustedData = Object.assign({}, data);
  adjustedData.eventData = Object.assign({}, data.eventData);
  'position userResponse itemId'.split(' ').forEach(function (prop) {
    adjustedData[prop] = adjustedData.eventData[prop];
    delete adjustedData.eventData[prop];
  });
  return adjustedData;
});
export var EVENT_RESPONSE = eventType();
export var SESSION_STARTED_OR_RESUMED_EVENT = eventType();
export var QUIZ_SUBMISSION_EVENT = eventType();
export var RCE_EVENT = eventType();
export var PAGE_BLURRED_EVENT = eventType();
export var PAGE_FOCUSED_EVENT = eventType();